import React, { FC } from 'react';
import styled from 'styled-components';
import ReactLoading from 'react-loading';

import * as testIds from './testIds';

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 30px;
  width: 100%;
  height: 100%;
  min-height: 100px;
  background: rgba(255, 1255, 255, 0.5);
`;

export const Loading: FC = () => (
  <LoadingWrapper data-testid={testIds.loading}>
    <ReactLoading
      type="spinningBubbles"
      color="#52bad5"
      height="50px"
      width="50px"
    />
  </LoadingWrapper>
);
